export default __webpack_public_path__ + "static/imperfective-past-dd445e460feb0a10423d1f70610d920b.svg";